import React, { useContext, useEffect, useState } from 'react';
import { BasketOutlined } from 'jl-design-system/components/icons/BasketOutlined';
import { BasketAmount } from '../basket-amount/BasketAmount';
import parseCookies from '../../../lib/cookie/parser';
import { createUserProfile } from '../../../lib/cookie/user/profile';
import { EnvVarsFeaturesContext } from '../../scaffold/EnvVarsFeaturesContext';
import { UserContext } from '../../scaffold/UserContext';
import { isMin1024pxWide } from '../../utils/device/identifyDevice';
import { notifyNavAnalytics } from '../navigation/notify-analytics';
import styles from './basket.scss';

const isClient = () => typeof window !== 'undefined' && window.document;
export const Basket = ({ children: label }) => {
  const [componentMounted, setComponentMounted] = useState(false);

  const {
    envVars: { headerMinibasketActive },
  } = useContext(EnvVarsFeaturesContext);

  const {
    userState: {
      user: {
        basket: { items },
      },
    },
    updateUserState,
  } = useContext(UserContext);

  const handleUserProfileUpdate = () => {
    if (isClient()) {
      const cookies = parseCookies();
      const userProfile = createUserProfile(cookies);
      updateUserState(userProfile);
    }
  };

  const handleBasketButtonClick = event => {
    if (isClient() && headerMinibasketActive && window.isMinibasketLoaded) {
      event.preventDefault();
      const customEvent = new global.window.CustomEvent(
        'jl-events.browser.showMinibasket',
        {
          detail: {
            source: 'page-level',
          },
        }
      );
      window.dispatchEvent(customEvent);
    }
    if (!isMin1024pxWide()) {
      notifyNavAnalytics('mv', 'Basket');
    }
  };

  useEffect(() => {
    if (!componentMounted) {
      window.addEventListener(
        'jl-events.browser.basketQuantityUpdated',
        handleUserProfileUpdate,
        false
      );
      setComponentMounted(true);
    }

    return () => {
      window.removeEventListener(
        'jl-events.browser.basketQuantityUpdated',
        handleUserProfileUpdate,
        false
      );
    };
  }, []);

  return (
    <a
      id="minibasket-icon-anchor"
      className={styles.link}
      onClick={event => handleBasketButtonClick(event)}
      href="/basket"
      data-test="basket-anchor"
      data-testid="basket-anchor"
      aria-label="View your basket"
    >
      <BasketAmount basketItems={items} />
      <BasketOutlined className={styles.icon} size="medium" />
      {label}
    </a>
  );
};
